const prepareLikeFields = function (firstName, lastName, email, phone, data) {

    let likeData = {}
    likeData['contactDetails'] = {}
    likeData['contactDetails']['firstName'] = firstName;
    likeData['contactDetails']['lastName'] = lastName;
    likeData['contactDetails']['phone'] = phone;
    likeData['contactDetails']['email'] = email;

    likeData['affordabilityResult'] = data['calculator_output']['maximum_balance']
    likeData['loanType'] = data['request']['loan_type']
    likeData['loanPurpose'] = data['request']['loan_purpose']
    likeData['stage'] = data['request']['stage']
    likeData['loanTermYears'] = data['request']['loan_term_requested'] / 12
    likeData['propertyValuation'] = data['request']['property_valuation']
    likeData['propertyRegion'] = data['request']['property_region']
    likeData['applicantsCount'] = data['request']['number_applicants']
    likeData['applicant1Income'] = data['request']['applicant'][0]['salary']

    if (likeData['applicantsCount'] > 1) {
        likeData['applicant2Income'] = data['request']['applicant'][1]['salary']
    }

    let ageGroup = parseInt(data['request']['ageGroup'])
    ageGroup = ageGroup >= 50 ? `${ageGroup}+` : `${ageGroup}-${ageGroup + 9}`

    likeData['applicantAgeGroup'] = ageGroup
    likeData['applicantPostcode'] = data['request']['applicant'][0]['post_code']

    if (likeData['loanType'].toLowerCase() === 'residential') {
        likeData['residential'] = {}
        likeData['residential']['isFirstTimeBuyer'] = data['request']['applicant'][0]['ftb']
        likeData['residential']['propertyUse'] = data['request']['propertyUse']
        likeData['residential']['deposit'] = data['request']['deposit']
        likeData['residential']['fixedRateYears'] = data['request']['product_initial_rate_period'] / 12
        likeData['residential']['creditExpenditure'] = data['request']['credit_expenditure']
        likeData['residential']['occupation'] = data['request']['job_title']
        likeData['residential']['dependentsOver17'] = data['request']['dependentsOver17']
        likeData['residential']['dependentsUnder16'] = data['request']['dependentsUnder16']
    }

    if (likeData['loanType'] === 'BTL') {
        //TODO

        // {
        //    applicantType: "Individual", // "Individual" or "LimitedCompany",
        //        existingPortfolio: true, // boolean
        //        monthlyRentalIncome: 6000,
        //
        //        // when existingPortfolio === true
        //        portfolio: {
        //            mortgagedPropertiesCount: 3,
        //            monthlyCombinedRentalIncome: 5200,
        //            totalEstimatedPropertiesValue: 2500000,
        //            totalOutstandingMortgagesAmount: 900000,
        //         },
        //    propertyIsHouseInMultipleOccupation: false, //boolean
        //    propertyIsMultiUnitBlock: false, //boolean
        // }
    }

    return likeData
}


const isLikeBusinessHours = function() {
    const now = new Date().toLocaleString("en-US", {timeZone: "Europe/London"});
    const ukTime = new Date(now);

    if (ukTime.getDay() > 5) {
        return false;
    }

    const hour = ukTime.getHours();
    const minute = ukTime.getMinutes();

    return hour >= 9 && (hour < 17 || (hour === 17 && minute <= 30));
}

export {
    prepareLikeFields,
    isLikeBusinessHours
}
